import { DownOutlined, LeftCircleFilled, LoadingOutlined, RightCircleFilled, SendOutlined } from "@ant-design/icons";
import { Button, Card, Col, Dropdown, Input, Layout, Menu, message, Modal, Row, Tooltip } from "antd";
import COACH_API from "api/coach";
import AUTH_API from "./../../api/auth";
import "bootstrap/dist/css/bootstrap.min.css";
import WeeklyReflections from "Components/Common/WeeklyReflections/WeeklyReflections";
import JobSearchBase from "Components/JobSearch/JobSearchbase";
import Learningbase from "Components/Learning/Learningbase";
import Materialsbase from "Components/Materials/Materialsbase";
import Midwaycall from "Components/Modals/Midwaycall";
import NewStep from "Components/Modals/NewStep";
import Profile from "Components/Modals/Profile";
import Skipstep from "Components/Modals/Skipstep";
import QuickReflection from "Components/Modals/Success";
import FeedbackModal from "Components/Modals/Feedback";
import ThankYou from "Components/Modals/Thanks";
import { CalendarBase } from "Components/Scheduler/CalendarBase";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect, Route, useHistory } from "react-router-dom";
import { fetchIndustriesAsync } from "slices/targetIndustriesSlice";
import { fetchRolesAsync } from "slices/targetRolesSlice";
import HELPERS, { WEEKLY_REFLECTION_TYPES } from "utils/helper";
// import {curr_active_map, } from "StaticVales"
import {
  fetchCoachSummaryAsync,
  fetchDataAsync,
  fetchProfessionalSummaryAsync,
  fetchShortTermGoalsAsync,
  fetchTimelineAsync,
  fetchTimelineStepAsync,
  fetchUpcomingMeetingsAsync,
  selectFetched,
  selectProfile,
  selectQuickReflectionInfo,
  selectShowThankYou,
  selectStepReflections,
  setShowThankYou,
  setStepNotifiedAsync,
  updateStepReflection,
} from "../../slices/dashboardSlice";
import steps, { canBeNotified, stepOrder, stepsAutoUnlockObj } from "../../utils/steps";
import DashboardComp from "../Dashboard/DashboardComp";
import Assessment from "./../Assessment/Assessment";
import Networkingbase from "./../Networking/Networkingbase";
import Researchindustries from "./../Researchindustries/Researchindustries";
import Researchroles from "./../Researchroles/Researchroles";
import Targetindustries from "./../Targetindustries/Targetindustries";
import Targetroles from "./../Targetroles/Targetroles";
// import "antd/dist/antd.css";
import "./Baselayout.css";
import TIdropdown from "./TIdropdown";
import TRdropdown from "./TRdropdown";
import MenuItem from "antd/lib/menu/MenuItem";
import axios from "axios";
import moment from "moment";
import Mytasks from "Components/Dashboard/MyTasks";
import Timeline from "Components/Dashboard/Timeline";
import ComingSoonScreenLayout from "./ComingSoonScreenLayout";
import { curr_active_map, curr_active_map_filter } from "./StaticValues";
import SearchBar from "Components/ReusableComponents/search";
import Notification from "Components/ReusableComponents/Notification";
import CustomizeDash from "Components/Dashboard/CustomizeDash";
import { fetchWorkEnvironmentsAsync } from "slices/targetWorkEnvironmentSlice";
import SearchResults from "Components/SearchResults/SearchResults";

const { Sider, Content } = Layout;
const { SubMenu } = Menu;

const menu = (
  <Menu>
    <Menu.Item>
      {/* <a target="_blank" rel="noopener noreferrer" href=""> */}
      Videos
      {/* </a> */}
    </Menu.Item>
    <Menu.Item>
      {/* <a target="_blank" rel="noopener noreferrer" href=""> */}
      Woken Book
      {/* </a> */}
    </Menu.Item>
    <Menu.Item>
      {/* <a target="_blank" rel="noopener noreferrer" href=""> */}
      Woken Blog
      {/* </a> */}
    </Menu.Item>
  </Menu>
);



const resources = (
  <Menu>
    <Menu.Item>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.youtube.com/channel/UCzENh4CtxdGdnsABkLHeAAg"
      >
        Videos
      </a>
    </Menu.Item>
    <Menu.Item>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://drive.google.com/file/d/1r0_pYv6MpTNXKBxlhK0aU9TjadZzMyOO/view"
      >
        Woken Book
      </a>
    </Menu.Item>
    <Menu.Item>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.iamwoken.com/resources"
      >
        Woken Blogs
      </a>
    </Menu.Item>
  </Menu>
);

const profileComp = (props) => (
  <Menu>
    {props.impersonated && (
      <Menu.Item onClick={() => props.showProfileModal(true)}>
        {/* <a target="_blank" rel="noopener noreferrer" href=""> */}
        Edit Profile
        {/* </a> */}
      </Menu.Item>
    )}
    <Menu.Item>
      <a target="_blank" rel="noopener noreferrer" href="/privacy-policy">
        Privacy Policy
      </a>
    </Menu.Item>
    {props.impersonated && (
      <Menu.Item
        onClick={() => {
          localStorage.removeItem("token");
          localStorage.removeItem("isCoach");
          window.heap.resetIdentity();
          setTimeout(function(){window.location.href = "/signin";}, 6000);
        }}
      >
        <a>Logout</a>
      </Menu.Item>
    )}
  </Menu>
);

const UserDropDown = (props) => {
  return (
    <Dropdown overlay={profileComp(props)} placement="bottomLeft">
      <Button type="text" style={{ color: "#111111" }}>
        {props.full_name} <DownOutlined />
      </Button>
    </Dropdown>
  );
};

const Baselayout = (props) => {
  const [timeCounter, setTimeCounter] = useState(0);
  const [saved, setSaved] = useState(false);
  const [draggedItem, setDraggedItem] = useState(null);
  const [value, setValue] = useState(0);
  const [mode, setMode] = useState("inline");
  // State to track which submenu is currently open
  const [openKeys, setOpenKeys] = useState([]);
  const [requestAccessmsg, setRequestAccessMsg] = useState({});
  const [showAccessInput, setShowAccessInput] = useState({});
  const submenuRef = useRef(null);
  const [collapsed, setCollapsed] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showNewStepModal, setShowNewStepModal] = useState(true);
  const [selected, setSelected] = useState(curr_active_map[window.location.pathname]);
  const showFeedback = useSelector(state => state.dashboard.show_feedback)
  const [pathName, setPathName] = useState(window.location.pathname);
  const stepReflections = useSelector(selectStepReflections);
  const quickReflectionInfo = useSelector(selectQuickReflectionInfo);
  const showThankYou = useSelector(selectShowThankYou);
  const profile = useSelector(selectProfile);
  const history = useHistory();
  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const dispatch = useDispatch();
  const full_name = () => profile ? `${profile.first_name} ${profile.last_name}` : "User";
  const impersonated = () => (profile ? profile.impersonated : false);
  const [visibleProfileModal, setVisibleProfileModal] = useState(false);
  const [tmpState, setTmpState] = useState(false);

  const setDynamicHeight = () => {
    const referenceElement = document.querySelector('.source-element');
    if (referenceElement) {
      const height = referenceElement.offsetHeight;
      document.documentElement.style.setProperty('--dynamic-height', `${height+12}px`);
    }
  }
  
  window.addEventListener('mousedown', setDynamicHeight);
  window.addEventListener('mouseup', setDynamicHeight);
  window.addEventListener('mousemove', setDynamicHeight);
  window.addEventListener('click', setDynamicHeight);
  window.addEventListener('scroll', setDynamicHeight);
  setDynamicHeight();

  useEffect(() => {
    console.log("impersonated in use effect", impersonated(), profile);
    if (!curr_active_map_filter[window.location.pathname]) {
      //incorrect routes handled
      history.push("/");
    }
    if (window.location.pathname.endsWith("/dashboard") && collapsed) {
      HELPERS.log("I am not supposed to be collapsed!");
      setCollapsed(false);
    }

    if (!impersonated() && !localStorage.getItem("isCoach")) {
      console.log("impersonated!!");
      HELPERS.ping();
      if (saved) {
        message.success("Your work has been saved!");
      }
      // HELPERS.changesSaved(() => message.success("Your work has been saved!"));
    } else {
      console.log(" not impersonated!!");
      HELPERS.log("PING: Stop pinging.");
      HELPERS.stopPing();
    }
  }, []);

  // Function to handle outside click
  const handleClickOutside = (event) => {
    const section = document.querySelector(".main-left-container");
    
    if (
      openKeys.length > 1 &&
      section && section.contains(event.target) &&  // Clicked on the section
      submenuRef.current && !submenuRef.current.contains(event.target) // Not inside submenu
    ) {
      console.log("Clicked outside submenu on the section, closing menu.");
      setOpenKeys((prevKeys) => prevKeys.slice(0, 1)); // Close the submenu
    }
  };

  useEffect(() => {
    if (openKeys.length > 0) {
      document.addEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openKeys]);

  const changeMode = (value) => {
    setMode(value ? "vertical" : "inline");
  };

  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.subSteps) {
          func(item.subSteps, level + 1);
          // console.log("itemsubSteps", item.subSteps)
          
          item.subSteps.forEach((i) => {
            // console.log("satyam i", i)

            if(i.steps){
              i.steps.forEach((j) => {
                // console.log("satyam j", j)
                if (j.steps && Array.isArray(j.steps)) {
                  // console.log("itemsubStepssteps", j)
                  if (j.key) {
                    key[j.key] = level+2;
                  }
                  j.steps.forEach((k) => {
                    if (k.subSubStep && Array.isArray(k.subSubStep)) {
                      // console.log("itemsubStepsstepsk", k)
                      if (k.key) {
                        key[k.key] = level+3;
                      }
                    }
                  })
                }
              })
            }
          })
        }
      });
    };
    func(items1);
    return key;
  };

  const levelKeys = getLevelKeys(steps);
  // console.log("levelKeys", levelKeys);

  const onOpenChange = (keys) => {
    setOpenKeys((prevOpenKeys) => {
      const currentOpenKey = keys.find((key) => !prevOpenKeys.includes(key));
      if (!currentOpenKey || levelKeys[currentOpenKey] === undefined) {
          return keys;
      }

      const repeatIndex = keys
          .filter((key) => key !== currentOpenKey)
          .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);

      return keys
          .filter((_, index) => index !== repeatIndex)
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]);
    });
    // console.log('openKeys', openKeys)
  };

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const showProfileModal = (visible) => {
    setVisibleProfileModal(visible);
  };

  const stepReflectionsRequestAccessFlag = (step) => 
    stepReflections[step] ? stepReflections[step].flag : false;

  const stepReflectionsStepId = (step) =>
    stepReflections[step] ? stepReflections[step].id : null;

  const stepReflectionsStepStatus = (step) =>
    stepReflections[step] ? stepReflections[step].status : null;

  const isLocked = (step) =>
    stepReflections[step] ? stepReflections[step].status === "LO" : false;

  const isUnlocked = (step) =>
    stepReflections[step] ? stepReflections[step].status === "UN" : false;
  
  const isReview = (step) =>
    stepReflections[step] ? stepReflections[step].status === "RE" : false;

  const isOngoing = (step) =>
    stepReflections[step] ? stepReflections[step].status === "ON" : false;

  const isDone = (step) =>
    stepReflections[step] ? stepReflections[step].status === "DO" : false;

  const isContinuous = (step) =>
    stepReflections[step] ? stepReflections[step].status === "CO" : false;

  const justLaunched = (step) =>
    // stepReflections[step] ? !isLocked(step) && stepReflections[step].notified === false : false;
    stepReflections[step] ? isUnlocked(step) && stepReflections[step].notified === false : false;
    // stepReflections[step] ? stepReflections[step].status === "UN" : false;

  const goToOnboarding = () => {
    console.log("going to onboarding");
    // props.history.push({
    //   pathname: '/onboarding',
    //   state: { curr: 4 }
    // })
    return (
      <Redirect to={{ pathname: "/onboarding", stepProps: { curr: 3 } }} />
    );
  };
  console.log('stepReflections', stepReflections)
  
  const handleStepMenuActions = (menu, action, id) => {
    console.log("sss menu:", menu, 'action:', action, 'id:', id);
    const data = {
      id: id,
      step: menu,
      status: action,
      flag: action === "LO" ? false : true
    };
    console.log("patch api data:", data, "step_id", id);
    AUTH_API.CoachStepsPatch(data, id)
      .then((response) => {
        console.log("patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: menu,
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });
    if(menu === "GW"){
      const IdGW = stepReflectionsStepId("GC");
      const dataGW = {
        id: IdGW,
        step: "GC",
        status: action,
        flag: action === "LO" ? false : true
      };
      AUTH_API.CoachStepsPatch(dataGW, IdGW)
      .then((response) => {
        console.log("patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: "GC",
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });
    }
    if(menu === "NN"){
      const IdPI = stepReflectionsStepId("PI");
      const dataPI = {
        id: IdPI,
        step: "PI",
        status: action,
        flag: action === "LO" ? false : true
      };
      AUTH_API.CoachStepsPatch(dataPI, IdPI)
      .then((response) => {
        console.log("patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: "PI",
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });
    }
    // for releasing target roles/industries
    if(menu === "AE"){
      const IdTI = stepReflectionsStepId("TI");
      const dataTI = {
        id: IdTI,
        step: "TI",
        status: action,
        flag: action === "LO" ? false : true
      };
      AUTH_API.CoachStepsPatch(dataTI, IdTI)
      .then((response) => {
        console.log("patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: "TI",
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });

      const IdTR = stepReflectionsStepId("TR");
      const dataTR = {
        id: IdTR,
        step: "TR",
        status: action,
        flag: action === "LO" ? false : true
      };
      AUTH_API.CoachStepsPatch(dataTR, IdTR)
      .then((response) => {
        console.log("patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: "TR",
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });

      console.log("TI", dataTI, "TR", dataTR);
    }
    // for releasing call notes
    if((menu === "CP" && action === 'UN') && isLocked("CN")){
      console.log('sss CP unlock', menu, action)

      const IdCN = stepReflectionsStepId("CN");
      const dataCN = {
        id: IdCN,
        step: "CN",
        status: action,
        flag: action === "LO" ? false : true
      };
      AUTH_API.CoachStepsPatch(dataCN, IdCN)
      .then((response) => {
        console.log("sss patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: "CN",
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });
    }

    if((menu === "NT" && action === 'UN')){
      console.log('sss NT unlock', menu, action)
      
      // for releasing call notes
      if(isLocked("CN")){
        const IdCN = stepReflectionsStepId("CN");
        const dataCN = {
          id: IdCN,
          step: "CN",
          status: action,
          flag: action === "LO" ? false : true
        };
        AUTH_API.CoachStepsPatch(dataCN, IdCN)
          .then((response) => {
          console.log("sss patch api response", response)
          if (response && response.data) {
            dispatch(
              updateStepReflection({
                stepKey: "CN",
                data: { status: response.data.status }
              })
            );
          }
        })
        .catch((err) => {
          console.log("patch api error", err)
        });
      }

      // for releasing call prep
      if(isLocked('CP')){
        const IdCP = stepReflectionsStepId("CP");
        const dataCP = {
          id: IdCP,
          step: "CP",
          status: action,
          flag: action === "LO" ? false : true
        };
        AUTH_API.CoachStepsPatch(dataCP, IdCP)
        .then((response) => {
          console.log("sss patch api response", response)
          if (response && response.data) {
            dispatch(
              updateStepReflection({
                stepKey: "CP",
                data: { status: response.data.status }
              })
            );
          }
        })
        .catch((err) => {
          console.log("patch api error", err)
        });
      }

    }

    // for releasing interview research
    if((menu === "AT" && action === 'UN')){
      console.log('sss AT unlock', menu, action)

      const IdIR = stepReflectionsStepId("IR");
      const dataIR = {
        id: IdIR,
        step: "IR",
        status: action,
        flag: action === "LO" ? false : true
      };
      AUTH_API.CoachStepsPatch(dataIR, IdIR)
      .then((response) => {
        console.log("sss patch api response", response)
        if (response && response.data) {
          dispatch(
            updateStepReflection({
              stepKey: "IR",
              data: { status: response.data.status }
            })
          );
        }
      })
      .catch((err) => {
        console.log("patch api error", err)
      });
    }

  }
  
  const inProgressMenuActions = (stepName, id, menuLink) => (
    <>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "DO", id);
          }}
          >
          Mark as Done
        </a>
      </p>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "LO", id);
          }}
          >
          Lock this Step
        </a>
      </p>
      <p>
      <Link to={menuLink}>Review this Step</Link>
        {/* <a
          rel="noopener noreferrer"
          href={menuLink}
          // onClick={(e) => {
          //   e.preventDefault(); // Prevent default link behavior
          //   handleStepMenuActions(stepName, "RE", id);
          // }}
          >
          Review this Step
        </a> */}
      </p>
    </>
  );
  
  const doneMenuActions = (stepName, id, menuLink) =>(
    <>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "ON", id);
          }}
          >
          Mark as In Progress
        </a>
      </p>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "LO", id);
          }}
          >
          Lock this Step
        </a>
      </p>
      <p>
        <Link to={menuLink}>Review this Step</Link>
        {/* <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "RE", id);
          }}
          >
          Review this Step
        </a> */}
      </p>
    </>
  );
  
  const reviewMenuActions = (stepName, id) =>(
    <>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "ON", id);
          }}
          >
          Mark as In Progress
        </a>
      </p>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "DO", id);
          }}
          >
          Mark as Done
        </a>
      </p>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "LO", id);
          }}
          >
          Lock this Step
        </a>
      </p>
    </>
  );

  const newORNotStartedMenuActions = (stepName, id, menuLink) =>(
    <>
      <p>
        <Link to={menuLink}>Review this Step</Link>
        {/* <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "RE", id);
          }}
        >
          Review this Step
        </a> */}
      </p>
      <p>
        <a
          rel="noopener noreferrer"
          href="#"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            handleStepMenuActions(stepName, "LO", id);
          }}
          >
          Lock this Step
        </a>
      </p>
    </>
  );

  const handleSend = (menuKey, menuTitle) => {
    
    // Check if required values exist
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      console.error("Error: user_id is missing!");
      return;
    }
  
    const data = {
      id: stepReflectionsStepId(menuKey),
      step: menuKey,
      stepTitle: menuTitle,
      notes: requestAccessmsg[menuKey],
      currentDate: moment(),
      user_id: userId,
    };
    
    // console.log("Post API Data:", data);
    // console.log("API URL:", AUTH_API.requestAccess);
  
     AUTH_API.requestAccess(data)
       .then((response) => {
          console.log("Post API Response:", response);
          dispatch(
            updateStepReflection({
              stepKey: menuKey,
              data: { flag: true },
            })
          );
          setShowAccessInput((prev) => ({ ...prev, [menuKey]: false }));
          setRequestAccessMsg((prev) => ({ ...prev, [menuKey]: "" }))
       })
       .catch((err) => {
         console.error("Post API Error:", err);
       });

  };

  const handleChange = (menuKey, e) => {
    if (e.target.value.length > 250) {
      message.warning("Character limit exceeded!");
    } else {
      setRequestAccessMsg((prev) => ({ ...prev, [menuKey]: e.target.value }));
    }
  };

  const tooltipContent = (title, menuKey, text, menuStatus, impersonateStatus, menuLink) => (
    <>
      {!impersonateStatus ? (
        <>
          <p style={{ fontSize: "15px", lineHeight: "18px", marginBottom: "10px", }}>
            <strong><i>{title}</i></strong>{" "}
            <span dangerouslySetInnerHTML={{ __html: text }} />
          </p>
          {menuStatus && (
            <>
              {(!showAccessInput[menuKey] && !stepReflectionsRequestAccessFlag(menuKey)) && (
                <button
                  type="primary"
                  className="button-main"
                  onClick={() => {
                    setShowAccessInput((prev) => ({ ...prev, [menuKey]: true }));
                  }}
                  style={{ float: "right", padding: "1px 10px", fontSize: "14px",  }}
                >Request Access</button>
              )}
              {showAccessInput[menuKey] && !stepReflectionsRequestAccessFlag(menuKey) && (
                <>
                  <Input.TextArea
                    value={requestAccessmsg[menuKey] || ""}
                    className="request-access-input"
                    placeholder="Let your coach know why you'd like access to this tool at this time."
                    rows={4}
                    maxLength={250}
                    // onChange={handleChange}
                    onChange={(e) => handleChange(menuKey, e)}
                  />
                  <button
                    type="primary"
                    className="button-main"
                    onClick={() => {
                      handleSend(menuKey, title)
                      // setRequestAccessMsg((prev) => ({ ...prev, [menuKey]: "" }))
                      // setShowAccessInput((prev) => ({ ...prev, [menuKey]: false }));
                    }}
                    style={{ marginTop: "8px", float: "right", padding: "1px 10px", fontSize: "14px",  }}
                  >Send Request</button>
                </>
              )}
              {stepReflectionsRequestAccessFlag(menuKey) && (
                <>
                  <p style={{ fontSize: "17px", lineHeight: "18px", fontWeight: "700"}}>Your request was submitted to your coach.</p>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {!isLocked(menuKey) ? (

            // (isDone(menuKey) || isReview(menuKey) || isOngoing(menuKey) || justLaunched(menuKey)) || isUnlocked(menuKey)  ? (
              <>
              <div
                bordered={false}
                className="hover-menu-impersonate-section-title"
              >
                <span>Current Status: </span>
                <span
                  className={[
                    "menu-status",
                    isDone(menuKey) ? "done" : isReview(menuKey) ? "review" : isOngoing(menuKey) ? "ongoing" : justLaunched(menuKey) || isUnlocked(menuKey) ? "new-not-started" : "",
                  ].join(" ")}
                >
                  {
                    isDone(menuKey) ? "Marked as Done" : isReview(menuKey) ? "Ready for Review" : isOngoing(menuKey) ? "In Progress" : justLaunched(menuKey) || isUnlocked(menuKey) ? "New/Not Started" : "No Status"
                  }
                </span>
              </div>
              <div
                bordered={false}
                className={[
                  "hover-menu-impersonate-section-body",
                ].join(" ")}
              >
                <span className="body-title">Coach Actions:</span>
                <span>
                  {
                    isDone(menuKey) ? doneMenuActions(menuKey, stepReflectionsStepId(menuKey), menuLink) : isReview(menuKey) ? reviewMenuActions(menuKey, stepReflectionsStepId(menuKey)) : isOngoing(menuKey) ? inProgressMenuActions(menuKey, stepReflectionsStepId(menuKey), menuLink) : justLaunched(menuKey) || isUnlocked(menuKey) ? newORNotStartedMenuActions(menuKey, stepReflectionsStepId(menuKey), menuLink) : ""
                  }
                </span>
              </div>
            </>
            // ) : (
            //   <>
            //     <div
            //       bordered={false}
            //       className="hover-menu-impersonate-section"
            //     >
            //       <p style={{  marginTop: "5px", marginBottom: "5px" }}>
            //         <a
            //           rel="noopener noreferrer"
            //           href="#"
            //           onClick={(e) => {
            //             e.preventDefault(); // Prevent default link behavior
            //             handleStepMenuActions(menuKey, "LO", stepReflectionsStepId(menuKey));
            //           }}
            //         >
            //           Lock this Step
            //         </a>
            //       </p>
            //       <p style={{  marginTop: "5px", marginBottom: "5px" }}>
            //         <Link to={menuLink}>Review this Step</Link>
            //       </p>
            //     </div>
            //   </>
            // )          
          ) : (
            <>
              <div
                bordered={false}
                className="hover-menu-impersonate-section"
              >
                <p style={{  marginTop: "5px", marginBottom: "5px" }}>
                  <a
                    rel="noopener noreferrer"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default link behavior
                      handleStepMenuActions(menuKey, "UN", stepReflectionsStepId(menuKey));
                    }}
                  >
                    Unlock this Step
                  </a>
                </p>
              </div>
            </>
          )}
        </>
      ) }
    </>
  );

  const renderMenu = () => (
    <Menu
      style={{
        padding: "35px 12px 12px 12px",
        fontSize: "small",
        height: "100%",
        marginTop: "-3px",
        borderRight: "0px",
      }}
      // defaultOpenKeys={["sub2", "sub3", "sub4"]}
      mode={mode}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      selectedKeys={[curr_active_map[window.location.pathname]]} //CURRENT RELATIVE URL USED AS KEY TO INDEX DEFAULT KEY
    >
      {steps.map((step, i) => {
        const subSteps = [];
        let stepLocked = true;

        step.subSteps.forEach((subStep) => {
          let subStepLocked = !subStep.steps.some(
            (step) => isLocked(step.stepKey) === false
          );

          // If any sub step is not locked then consider step not locked
          if (!subStepLocked && stepLocked) {
            stepLocked = false;
          }

          if (subStep.title) {
            
            const subSteps2 = [];
            subStep.steps.forEach((step) => {
              
              !Array.isArray(step.steps) ?  
                subSteps2.push(
                  <Menu.Item
                    key={step.key}
                    className={[
                      step.stepKey && isLocked(step.stepKey) ? "locked" : "",
                      justLaunched(step.stepKey) ? "just-launched" : "",
                      !justLaunched(step.stepKey) && isOngoing(step.stepKey)
                        ? "ongoing"
                        : !justLaunched(step.stepKey) && isUnlocked(step.stepKey) ? "unlocked" : (!justLaunched(step.stepKey) && isReview(step.stepKey)) ? "review" : !justLaunched(step.stepKey) && isDone(step.stepKey) ? "done" : !justLaunched(step.stepKey) && isContinuous(step.stepKey) ? "continuous" : "",
                        "main-menu-level-2",
                        "extra-sidebar-menu",
                    ].join(" ")}
                  >
                    <Tooltip
                    overlay={
                      tooltipContent(step.title, step.stepKey, step.hoverText, (step.stepKey && isLocked(step.stepKey)), impersonated(), (!isLocked(step.stepKey) ? step.linkTo : "#"))
                    }
                    trigger="hover"
                    mouseEnterDelay={isUnlocked(step.stepKey) || justLaunched(step.stepKey) ? 0.1 : 0.1}
                    overlayClassName={[
                      (!step.hoverText && !impersonated()) ? isLocked(step.stepKey) ? "" : "ant-tooltip-hidden" : "",
                      "menu-hover-text",
                      impersonated() ? "menu-hover-text-impersonate" : "",
                      (!stepReflections[step.stepKey] && impersonated()) ? (!justLaunched(step.stepKey) && impersonated()) ? "ant-tooltip-hidden" : "" : "",
                      (stepsAutoUnlockObj[step.stepKey]?.auto_unlock && impersonated()) ? "ant-tooltip-hidden" : "",
                    ].join(" ")}
                    placement="rightTop">
                      
                      {step.stepKey === "AS" &&
                      isLocked(step.stepKey) &&
                      justLaunched(step.stepKey)
                        ? goToOnboarding()
                        : ""}
                      {String(step.linkTo).startsWith("http") ? (
                        <a
                          href={step.linkTo}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {step.title}
                        </a>
                      ) : ( 
                        <>
                          <Link to={!isLocked(step.stepKey) ?  step.linkTo : "#"}
                            onClick={() => {
                              setOpenKeys((prevKeys) => prevKeys.slice(0, 1));
                            }}
                            disabled={!isLocked(step.stepKey) ?  false : true}
                          >
                            {step.title}
                          </Link>
                          {
                            step.showStatusIcon ? !isContinuous(step.stepKey) ? <img
                            src={isOngoing(step.stepKey)
                              ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuOngingSmall.svg"
                              : (isReview(step.stepKey) && impersonated()) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuReviewSmall.svg" : isDone(step.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuDoneSmall.svg" : isUnlocked(step.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg" : justLaunched(step.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg" : ""}
                            width="20px" className="status-badge"
                          /> : "" : ""
                          }
                        </>
                      )}
                    </Tooltip>
                  </Menu.Item>
                )
              :
                (() => {
                  const subSteps3 = [];
                  step.steps.forEach((subStep) => {

                    subStep.subMenu ? (() => {

                      const subSteps4 = [];

                        subStep.subSubStep.forEach((subSubStep) => {

                          subSteps4.push(
                            subSubStep.sectionHeader ?
                              <p
                                key={`sub-steps-heading-${subSubStep.title}`}
                                className={subStepLocked ? "locked" : ""}
                                style={{ 
                                  padding: "6% 9% 6% 14px",
                                  fontSize: "15px",
                                  fontWeight: "400",
                                  position: "relative",
                                  top: "2px",
                                }}
                              >
                                {subSubStep.title.toUpperCase()}
                              </p>
                            :
                              <Menu.Item
                                key={subSubStep.key}
                                className={[
                                  subSubStep.stepKey && isLocked(subSubStep.stepKey) ? "locked" : "",
                                  justLaunched(subSubStep.stepKey) ? "just-launched" : "",
                                  !justLaunched(subSubStep.stepKey) && isOngoing(subSubStep.stepKey)
                                    ? "ongoing"
                                    : !justLaunched(subSubStep.stepKey) && isUnlocked(subSubStep.stepKey) ? "unlocked" : (!justLaunched(subSubStep.stepKey) && isReview(subSubStep.stepKey)) ? "review" : !justLaunched(subSubStep.stepKey) && isDone(subSubStep.stepKey) ? "done" : !justLaunched(subSubStep.stepKey) && isContinuous(subSubStep.stepKey) ? "continuous" : "",
                                    "main-menu-level-4",
                                    "full-length-extra-sidebar-menu-2",
                                ].join(" ")}
                              >
                                <Tooltip
                                overlay={
                                  tooltipContent(subSubStep.title, subSubStep.stepKey, subSubStep.hoverText, (subSubStep.stepKey && isLocked(subSubStep.stepKey)), impersonated(), (!isLocked(subSubStep.stepKey) ? subSubStep.linkTo : "#"))
                                }
                                trigger="hover"
                                mouseEnterDelay={isUnlocked(subSubStep.stepKey) || justLaunched(subSubStep.stepKey) ? 0.1 : 0.1}
                                overlayClassName={[
                                (!subSubStep.hoverText && !impersonated()) ? isLocked(subSubStep.stepKey) ? "" : "ant-tooltip-hidden" : "",
                                  "menu-hover-text",
                                  impersonated() ? "menu-hover-text-impersonate" : "",
                                  (!stepReflections[subSubStep.stepKey] && impersonated()) ? (!justLaunched(subSubStep.stepKey) && impersonated()) ? "ant-tooltip-hidden" : "" : "",
                                  (stepsAutoUnlockObj[subSubStep.stepKey]?.auto_unlock && impersonated()) ? "ant-tooltip-hidden" : "",
                                ].join(" ")}
                                placement="rightTop">

                                  {subSubStep.stepKey === "AS" &&
                                  isLocked(subSubStep.stepKey) &&
                                  justLaunched(subSubStep.stepKey)
                                    ? goToOnboarding()
                                    : ""}
                                  {String(subSubStep.linkTo).startsWith("http") ? (
                                    <a
                                      href={subSubStep.linkTo}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {subSubStep.title}
                                    </a>
                                  ) : ( 
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          gap: "11px",
                                          alignItems: "center",
                                        }}
                                      >
                                        <span className="menu-item-bullet"></span>
                                        <Link to={!isLocked(subSubStep.stepKey) ? subSubStep.linkTo : "#"}
                                          onClick={() => {
                                            setOpenKeys((prevKeys) => prevKeys.slice(0, 1));
                                          }}
                                          disabled={!isLocked(subSubStep.stepKey) ?  false : true}
                                        >
                                          {subSubStep.title}
                                        </Link>
                                      </div>
                                      {
                                        subSubStep.showStatusIcon ? !isContinuous(subSubStep.stepKey) ? <img
                                        src={isOngoing(subSubStep.stepKey)
                                          ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuOngingSmall.svg"
                                          : (isReview(subSubStep.stepKey) && impersonated()) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuReviewSmall.svg" : isDone(subSubStep.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuDoneSmall.svg"
                                          : isUnlocked(subSubStep.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg"
                                          : justLaunched(subSubStep.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg" :""}
                                        width="20px" className="status-badge"
                                      /> : "" : ""
                                      }
                                    </>
                                  )}
                                </Tooltip>  
                              </Menu.Item>
                          )
                        })
                        
                        subSteps3.push(
                          <SubMenu
                            style={{ borderRight: "3px !important", marginBottom: "0px" }}
                            key={subStep.key}
                            title={subStep.title}
                            className={[
                              stepLocked ? "locked" : "",
                              subStep.title.toLowerCase(),
                              "main-menu-level-3",
                              "full-length-extra-sidebar-menu",
                              "full-length-extra-sidebar-menu-3",
                              ""
                              // "dev2"
                            ].join(" ")}
                          >
                            {subSteps4}
                          </SubMenu>
                        )
                    })()

                    :
                    subSteps3.push(

                      subStep.sectionHeader ?
                        <p
                          key={`sub-steps-heading-${subStep.title}`}
                          className={subStepLocked ? "locked" : ""}
                          style={{ 
                            padding: "6% 9% 6% 14px",
                            fontSize: "15px",
                            fontWeight: "400",
                            position: "relative",
                            top: "2px",
                          }}
                        >
                          {subStep.title.toUpperCase()}
                        </p>
                      :

                        <Menu.Item
                          key={subStep.key}
                          className={[
                            subStep.stepKey && isLocked(subStep.stepKey) ? "locked" : "",
                            justLaunched(subStep.stepKey) ? "just-launched" : "",
                            !justLaunched(subStep.stepKey) && isOngoing(subStep.stepKey)
                              ? "ongoing"
                              : !justLaunched(subStep.stepKey) && isUnlocked(subStep.stepKey) ? "unlocked" : (!justLaunched(subStep.stepKey) && isReview(subStep.stepKey)) ? "review" : !justLaunched(subStep.stepKey) && isDone(subStep.stepKey) ? "done" : !justLaunched(subStep.stepKey) && isContinuous(subStep.stepKey) ? "continuous" : "",
                              "main-menu-level-3",
                              "full-length-extra-sidebar-menu-2",
                          ].join(" ")}
                        >
                          <Tooltip
                          overlay={
                            tooltipContent(subStep.title, subStep.stepKey, subStep.hoverText, (subStep.stepKey && isLocked(subStep.stepKey)), impersonated(), (!isLocked(subStep.stepKey) ? subStep.linkTo : "#"))
                          }
                          trigger="hover"
                          mouseEnterDelay={isUnlocked(subStep.stepKey) || justLaunched(subStep.stepKey) ? 0.1 : 0.1}
                          overlayClassName={[
                            (!subStep.hoverText && !impersonated()) ? isLocked(subStep.stepKey) ? "" : "ant-tooltip-hidden" : "",
                            "menu-hover-text",
                            impersonated() ? "menu-hover-text-impersonate" : "",
                            (!stepReflections[subStep.stepKey] && impersonated()) ? (!justLaunched(subStep.stepKey) && impersonated()) ? "ant-tooltip-hidden" : "" : "",
                            (stepsAutoUnlockObj[subStep.stepKey]?.auto_unlock && impersonated()) ? "ant-tooltip-hidden" : "",
                          ].join(" ")}
                          placement="rightTop">

                            {subStep.stepKey === "AS" &&
                            isLocked(subStep.stepKey) &&
                            justLaunched(subStep.stepKey)
                              ? goToOnboarding()
                              : ""}
                            {String(subStep.linkTo).startsWith("http") ? (
                              <a
                                href={subStep.linkTo}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {subStep.title}
                              </a>
                            ) : ( 
                              <>
                                <Link to={!isLocked(subStep.stepKey) ? subStep.linkTo : "#"} 
                                  onClick={() => {
                                    setOpenKeys((prevKeys) => prevKeys.slice(0, 1));
                                  }}
                                  disabled={!isLocked(subStep.stepKey) ?  false : true}
                                >
                                  {subStep.title}
                                </Link>
                                {
                                  subStep.showStatusIcon ? !isContinuous(subStep.stepKey) ? <img
                                  src={isOngoing(subStep.stepKey)
                                    ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuOngingSmall.svg"
                                    : (isReview(subStep.stepKey) && impersonated()) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuReviewSmall.svg" : isDone(subStep.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuDoneSmall.svg"
                                    : isUnlocked(subStep.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg"
                                    : justLaunched(subStep.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg" : ""}
                                  width="20px" className="status-badge"
                                /> : "" : ""
                                }
                              </>
                            )}
                          </Tooltip>  
                        </Menu.Item>
                    );
                  });
                  
                  subSteps2.push(
                    <SubMenu
                      style={{ borderRight: "3px !important", marginBottom: "5px" }}
                      key={step.key}
                      title={step.title}
                      className={[
                        stepLocked ? "locked" : "",
                        step.title.toLowerCase(),
                        "main-menu-level-2",
                        "full-length-extra-sidebar-menu",
                        // "dev2"
                      ].join(" ")}
                    >
                      {subSteps3}
                    </SubMenu>
                  )

                })()
            })
            
            subSteps.push(
              <SubMenu
                style={{ borderRight: "3px !important", marginBottom: "5px" }}
                key={subStep.key}
                title={subStep.title}
                // motion={{
                //   motionName: "slide-up",
                //   motionAppear: true,
                // }}
                // onClick={() => setIsExpanded(!isExpanded)}
                className={[
                  stepLocked ? "locked" : "",
                  subStep.title.toLowerCase(),
                  "main-menu-level-1",
                  // "satyam0"
                ].join(" ")}
              >
                {subSteps2}
              </SubMenu>
            )
          }
          else{

            subStep.steps.forEach((step) => {
              subSteps.push(
                <Menu.Item
                  key={step.key}
                  className={[
                    step.stepKey && isLocked(step.stepKey) ? "locked" : "",
                    justLaunched(step.stepKey) ? "just-launched" : "",
                    !justLaunched(step.stepKey) && isOngoing(step.stepKey)
                      ? "ongoing"
                      : !justLaunched(step.stepKey) && isUnlocked(step.stepKey) ? "unlocked" : (!justLaunched(step.stepKey) && isReview(step.stepKey)) ? "review" : !justLaunched(step.stepKey) && isDone(step.stepKey) ? "done" : !justLaunched(step.stepKey) && isContinuous(step.stepKey) ? "continuous" : "",
                  ].join(" ")}
                > 
                  <Tooltip
                  overlay={
                    tooltipContent(step.title, step.stepKey, step.hoverText, (step.stepKey && isLocked(step.stepKey)), impersonated(), (!isLocked(step.stepKey) ? step.linkTo : "#"))
                  }
                  trigger="hover"
                  mouseEnterDelay={isUnlocked(step.stepKey) || justLaunched(step.stepKey) ? 0.1 : 0.1}
                  overlayClassName={[
                    (!step.hoverText && !impersonated()) ? (isLocked(step.stepKey)) ? step.showRequestAccess ? "" : "ant-menu-hidden" : "ant-tooltip-hidden" : "",
                    "menu-hover-text",
                    impersonated() ? "menu-hover-text-impersonate" : "",
                    (!stepReflections[step.stepKey] && impersonated()) ? (!justLaunched(step.stepKey) && impersonated()) ? "ant-tooltip-hidden" : "" : "",
                    (!step.showRequestAccess && impersonated()) ? "ant-tooltip-hidden" : "",
                    (stepsAutoUnlockObj[step.stepKey]?.auto_unlock && impersonated()) ? "ant-tooltip-hidden" : "",
                  ].join(" ")}
                  placement="rightTop">
                    
                    {step.stepKey === "AS" &&
                    isLocked(step.stepKey) &&
                    justLaunched(step.stepKey)
                      ? goToOnboarding()
                      : ""}
                    {String(step.linkTo).startsWith("http") ? (
                      <a
                        href={step.linkTo}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {step.title}
                      </a>
                    ) : ( 
                      <>
                        <Link to={!isLocked(step.stepKey) ? step.linkTo : "#"}
                          {...(step.onClick && { onClick: step.onClick })}
                          disabled={!isLocked(step.stepKey) ?  false : true}
                          {...(step.key === '72' ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        >
                          {step.title}
                        </Link>
                        {
                          step.showStatusIcon ? !isContinuous(step.stepKey) ? <img
                          src={isOngoing(step.stepKey)
                            ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuOngingSmall.svg"
                            : (isReview(step.stepKey) && impersonated()) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuReviewSmall.svg" : isDone(step.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuDoneSmall.svg" : isUnlocked(step.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg" : justLaunched(step.stepKey) ? "https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/menuUnlockedSmall.svg" : ""}
                          width="20px" className="status-badge"
                        /> : "" : ""
                        }
                      </>
                    )}
                  </Tooltip>
                </Menu.Item>
              );
            });

          }

        });

        // Render Menu.Item if no subSteps, otherwise SubMenu
        if (!step.subSteps || step.subSteps.length === 0) {
          return (
            <Menu.Item
            style={{ borderRight: "3px !important", }}
            key={step.key}
            title={step.title}
            >
              <div className="ant-menu-submenu-title">
                <Link to={step.linkTo} 
                  onClick={() => {
                    setOpenKeys((prevKeys) => prevKeys.slice(0, 1));
                  }}
                >
                  <span>
                    <img
                      src={step.icon}
                      width="20px"
                      height="20px"
                      // alt={step.title}
                      style={{
                        // width: "15px",
                        // height: "15px",
                        // marginRight: "8px",
                        verticalAlign: "middle",
                        // gap: 0px;
                        top: "-0.5px",
                        left: "-1.5px",
                        position: "relative",
                        borderRadius: "1px 0px 0px 0px",
                        border: "1px 0px 0px 0px",
                        opacity: "0px",

                      }}
                    />
                    {step.title}
                  </span>
                </Link>
              </div>
            </Menu.Item>
          )
        }

        return (
          <SubMenu
            style={{ borderRight: "3px !important", marginBottom: "5px" }}
            key={step.key}
            // title={step.title}
            title={
              <span>
                <img
                  src={step.icon}
                  width="20px"
                  height="20px"
                  alt={step.title}
                  style={{
                    // marginRight: "8px",
                    verticalAlign: "middle",
                    // gap: 0px;
                    top: "-0.5px",
                    left: "-1.5px",
                    position: "relative",
                    borderRadius: "1px 0px 0px 0px",
                    border: "1px 0px 0px 0px",
                    opacity: "0px",

                  }}
                />
                {step.title}
              </span>
            }
            className={[
              stepLocked ? "locked" : "",
              step.title.toLowerCase(),
              "main-menu-level-0"
            ].join(" ")}
          >
            {subSteps}
          </SubMenu>
        );
      })}
    </Menu>
  );
  console.log(
    "$$woken$$",
    "base rendered",
    "fetched",
    props.fetched,
    "impersonated",
    impersonated(),
    // props,
    showNewStepModal,
    { mode, collapsed, visible, selected, pathName, stepReflections },
    window.location.pathname
  );
  const d = new Date();
  console.log(d.getMonth() + 1);

  const notifiedNewStep = (item) => {
    let temp = { ...showNewStepModal };
    temp[item] = false;
    console.log("close!!", temp);
    setShowNewStepModal(temp);
    // setValue(value+1)
    // dispatch(setStepNotifiedAsync(stepReflections[item].id, stepReflections[item]));
  };

  const newStepAvailable = () => {
    let newStep = [];

    for (let stepReflection in stepReflections) {
      if (justLaunched(stepReflection)) {
        if (
          canBeNotified(stepReflection)
          // && (newStep === null || stepOrder(stepReflection) < stepOrder(newStep))
        ) {
          newStep.push(stepReflection);
        }
      }
    }
    if (typeof showNewStepModal !== "object" && newStep.length) {
      console.log("is object!!");
      let temp = {};
      newStep.forEach((item) => {
        temp[item] = true;
      });
      setShowNewStepModal(temp);
    }
    // console.log("new Step", newStep);
    // return newStep;
  };

  const stopImpersonating = () => {
    COACH_API.stopImpersonate()
      .then(() => {
        // window.close();
        window.location.href = "/coach";
      })
      .catch(() => {
        message.error("Something went wrong. Try reloading the page!");
      });
  };

  return (
    <>
      {console.log("time??")}

      {props.fetched ? (
        <div
          className="headerimage"
          style={{ backgroundColor: "#ffffff", height: "100vh" }}
        >
          {/* <div
            className="impersonating-wrapper"
            style={{
              display: impersonated() ? "block" : "none",
            }}
          >
            <span>
              Impersonate Mode on.{" "}
              <span onClick={stopImpersonating}>Stop impersonating</span>
            </span>
          </div> */}

          {newStepAvailable()}
          <Layout style={{ backgroundColor: "#f5f5f500" }}>
            <Content style={{ backgroundColor: "#111111", overflowX: "visible", minHeight: "150vh"}} className={[
                "source-element main-right-container",
                (collapsed ?  "right-sidebar-hide" : ""),
              ].join(" ")} >
              <div style={{ padding: '15px', width: '100%', backgroundColor: '#111111', textAlign: 'left', padding: "35px 0px 5px 17px" }} className="site-logo-div">
                <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/logo.png" width="123.95px" height="32px" />
              </div>
              <Sider
                width="100%"
                style={{ backgroundColor: "#f5f5f500", padding: "0% 0 0"}}
                collapsed={collapsed}
              >
                <div
                  ref={submenuRef}
                >
                  {renderMenu()}
                </div>
              </Sider>
            </Content>
            <Layout style={{ backgroundColor: "#f5f5f500" }} className="main-left-container">
              <Content style={{ backgroundColor: "#f5f5f500", }}>
                
                <div style={{boxShadow: "0px 4px 20px 0px #0000000F"}}>
                  <Row style={{ minHeight: "72px", maxHeight:"72px", alignItems: "center", padding: "0 20px", }}>

                    {/* <Col span={9}> */}
                    <Col span={4}>
                      <div 
                      className="username-header-top"
                      style={{ 
                        textAlign: "left",
                        fontSize: "20px",
                        fontWeight: '800',
                        color: "#111111",
                        padding: "2% 1%",
                        fontFamily:'AvenirBook',
                        width: 'fit-content',
                        lineHeight: "27.32px",
                        display: "flex",
                            gap: "20px",
                            alignItems: "center",
                        }}>
                        {/* <Link
                          to={{
                            pathname: "/dashboard",
                            stepProps: { collapsed: false },
                          }}
                        >
                          <Button
                            type="text"
                            style={{ fontWeight: "bold", color: "white" }}
                            onClick={() => {
                              setSelected("0");
                            }}
                          >
                            Dashboard
                          </Button>
                        </Link> */}
                        <Link 
                          to="/dashboard"
                        >
                          Welcome, {profile ? profile.first_name : "User"}!
                        </Link>
                        {/* <div>
                          <Link to="/calendar">
                            <Button
                              type="text"
                              style={{ fontWeight: "bold", color: "#111111", paddingTop: "6px" }}
                            >
                              Calendar
                            </Button>
                          </Link>
                          <Dropdown overlay={resources} placement="bottomRight">
                            <Button
                              type="link"
                              style={{ fontWeight: "bold", color: "#111111" }}
                            >
                              Resources
                              <DownOutlined />
                            </Button>
                          </Dropdown>
                        </div> */}
                        {/* Welcome, {profile ? profile.first_name : "User"}! */}
                      </div>
                    </Col>
                    {/* <Col span={15}> */}
                    <Col span={20}>
                      <div style={{ float: "right", display: "flex", alignItems: "center", columnGap: "10px"}}>
                      <div className="impersonating-wrapper ">
                        <button 
                          className="back-to-coach-button"
                          style={{
                            display: impersonated() ? "flex" : "none",
                            columnGap: "6px",
                            alignItems: "center",
                          }}
                          onClick={stopImpersonating}
                          > <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/backToCoachDash.svg" /> Back to Coach Dashboard</button>
                      </div>
                        <SearchBar
                          collapsed={collapsed}
                          {...props}
                          searchResults={searchResults}
                          searchQuery={searchQuery}
                          setSearchResults={setSearchResults}
                          setSearchQuery={setSearchQuery}
                          searchLoading={searchLoading}
                          setSearchLoading={setSearchLoading}
                        />
                        <Notification/>
                        {/* <TRdropdown />
                        <TIdropdown /> */}
                        <UserDropDown
                          {...props}
                          full_name={full_name()}
                          showProfileModal={showProfileModal}
                          impersonated={!impersonated()}
                        />
                        <CustomizeDash setDraggedItem={setDraggedItem} />
                      </div>
                    </Col>
                    {/* <div className="top-bar-container">
                            <h3 className="user-name">Welcome, Rachel</h3>
                            <div className="right-icon-container">
                              <div>

                                <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M17.9375 19.9453C17.8208 20.0602 17.6637 20.1247 17.5 20.125C17.334 20.1243 17.1747 20.06 17.0547 19.9453L13.6797 16.5625C12.2583 17.7564 10.4308 18.3555 8.57844 18.2348C6.72607 18.114 4.99182 17.2828 3.73738 15.9146C2.48294 14.5463 1.80518 12.7465 1.84545 10.8906C1.88571 9.03477 2.6409 7.2661 3.9535 5.9535C5.2661 4.6409 7.03477 3.88571 8.89063 3.84545C10.7465 3.80518 12.5463 4.48294 13.9146 5.73738C15.2828 6.99182 16.114 8.72607 16.2348 10.5784C16.3555 12.4308 15.7564 14.2583 14.5625 15.6797L17.9375 19.0547C17.9966 19.1128 18.0434 19.1822 18.0755 19.2586C18.1075 19.3351 18.124 19.4171 18.124 19.5C18.124 19.5829 18.1075 19.6649 18.0755 19.7414C18.0434 19.8178 17.9966 19.8872 17.9375 19.9453ZM9.0625 17C10.2368 17 11.3848 16.6518 12.3612 15.9993C13.3376 15.3469 14.0986 14.4196 14.548 13.3347C14.9974 12.2497 15.115 11.0559 14.8859 9.90415C14.6568 8.75239 14.0913 7.69443 13.2609 6.86405C12.4306 6.03368 11.3726 5.46819 10.2208 5.23909C9.06909 5.00999 7.87525 5.12757 6.79032 5.57696C5.70538 6.02636 4.77807 6.78738 4.12565 7.7638C3.47323 8.74022 3.125 9.88817 3.125 11.0625C3.12707 12.6366 3.75329 14.1456 4.86634 15.2587C5.97938 16.3717 7.48841 16.9979 9.0625 17Z" fill="black"/>
                                </svg>
                              </div>
                            <div>

                                <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.6679 19.5001H8.33461M15.0013 8.66675C15.0013 7.34067 14.4745 6.0689 13.5368 5.13121C12.5991 4.19353 11.3274 3.66675 10.0013 3.66675C8.6752 3.66675 7.40343 4.19353 6.46574 5.13121C5.52806 6.0689 5.00128 7.34067 5.00128 8.66675C5.00128 11.2419 4.35167 13.005 3.626 14.1713C3.01388 15.155 2.70783 15.6468 2.71905 15.784C2.73147 15.936 2.76366 15.9939 2.88609 16.0847C2.99666 16.1667 3.4951 16.1667 4.49199 16.1667H15.5106C16.5075 16.1667 17.0059 16.1667 17.1165 16.0847C17.2389 15.9939 17.2711 15.936 17.2835 15.784C17.2947 15.6468 16.9887 15.155 16.3766 14.1713C15.6509 13.005 15.0013 11.2419 15.0013 8.66675Z" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <circle cx="14" cy="4" r="4" fill="#FF4747"/>
                                </svg>
                              </div>
                            <div>

                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M18.9166 11.25L17.2505 9.58333L15.5833 11.25M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C12.7516 2.5 15.1571 3.98178 16.4621 6.19091M10 5.83333V10L12.5 11.6667" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                          </div>

                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M17.5 17.5H5.16667C4.23325 17.5 3.76654 17.5 3.41002 17.3183C3.09641 17.1586 2.84144 16.9036 2.68166 16.59C2.5 16.2335 2.5 15.7668 2.5 14.8333V2.5M5.83333 12.0833V14.5833M9.58333 9.58333V14.5833M13.3333 7.08333V14.5833M17.0833 4.58333V14.5833" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                          <button className="customize-dashboard">Customize Dashboard</button>
                        </div>
                      </div> */}
                  </Row>
                </div>

                {/* <div
                  className="impersonating-wrapper"
                  style={{
                    display: impersonated() ? "block" : "none",
                  }}
                  >
                  <span>
                    Impersonate Mode on.{" "}
                    <span onClick={stopImpersonating}>Stop impersonating</span>
                  </span>
                </div> */}

                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                }}>
                  <div className="collapse-btn" onClick={toggle}>
                    {collapsed ? (
                      !window.location.pathname.endsWith("/dashboard") && (
                        <RightCircleFilled className="make-white" />
                      )
                    ) : (
                      !window.location.pathname.endsWith("/dashboard") && (
                        <LeftCircleFilled className="make-white" />
                      )
                    )}
                  </div>
                  {/* <div
                    className="impersonating-wrapper"
                    style={{
                      display: impersonated() ? "block" : "none",
                    }}
                    >
                    <span>
                      Impersonate Mode on.{" "}
                      <span onClick={stopImpersonating}>Stop impersonating</span>
                    </span>
                  </div> */}
                </div>

                <div style={{marginTop: `${!window.location.pathname.endsWith("/dashboard") ? "15px" : impersonated() ? "50px" : "50px"}`}}>
                  <Route
                    path="/search-results"
                    exact
                    render={(props) => (
                      <SearchResults
                        collapsed={collapsed}
                        {...props}
                        searchResults={searchResults}
                        searchQuery={searchQuery}
                        searchLoading={searchLoading}
                        setSearchResults={setSearchResults}
                        setSearchQuery={setSearchQuery}
                        setSearchLoading={setSearchLoading}
                      />
                      )}
                  />
                  <Route
                    path="/accountability/my-schedule"
                    exact
                    render={(props) => (
                      <CalendarBase toggle={toggle} collapsed={collapsed} />
                    )}
                  />
                  <Route
                    path="/calendar"
                    exact
                    render={(props) => (
                      <CalendarBase toggle={toggle} collapsed={collapsed} />
                    )}
                  />
                  <Route
                    path="/dashboard"
                    exact
                    render={(props) => (
                      <DashboardComp
                        key={JSON.stringify(tmpState)} // Forces re-render on tmpState change
                        toggle={toggle}
                        tmpState={tmpState}
                        setTmpState={setTmpState}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  
                  <Route
                    path="/career-path-exploration/assessment"
                    exact
                    render={(props) => (
                      <Assessment
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        stepsStatus={stepReflections}
                      />
                    )}
                  />
                  <Route
                    path="/assessment"
                    exact
                    render={(props) => (
                      <Assessment
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        stepsStatus={stepReflections}
                      />
                    )}
                  />
                  {/* <Route
                    path="/career-path-exploration/target-roles-and-industries"
                    exact
                    render={(props) => (
                      <>
                        <Targetroles
                          toggle={toggle}
                          collapsed={collapsed}
                          impersonated={!impersonated()}
                          stepStatus={stepReflectionsStepStatus("TI")}
                          newStepId={stepReflectionsStepId("AE")}
                          newStepKey="AE"
                          {...props}
                          />
                        <Targetindustries
                          toggle={toggle}
                          impersonated={!impersonated()}
                          stepStatus={stepReflectionsStepStatus("TR")}
                          newStepId={stepReflectionsStepId("AE")}
                          newStepKey="AE"
                          collapsed={collapsed}
                          {...props}
                        />
                      </>
                    )}
                  /> */}
                  <Route
                    path="/career-path-exploration/target-roles"
                    exact
                    render={(props) => (
                      <Targetroles
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/target-industries"
                    exact
                    render={(props) => (
                      <Targetindustries
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/role-research"
                    exact
                    render={(props) => (
                      <Researchroles
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/agenda"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Agenda"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/coach-meetings"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Coach Meetings"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/meeting-notes"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Meeting Notes"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/coach-feedback"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Coach Feedback"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mission-statement"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Mission Statement"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/life-wheel"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Life Wheel"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/annual-goals"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Annual Goals"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/financial-management"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Financial Management"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/relationship-management"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Relationship Management"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/travel-and-adventure"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Travel & Adventure"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/giving-and-contribution"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Giving & Contribution"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/Spiritual"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Spiritual"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/health-and-wellness"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Health & Wellness"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/location-to-live"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Location to Live"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/peers"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Peers"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/therapist"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Therapist"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/stakeholders"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Stakeholders"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/manager"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Manager"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mentors"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Mentors"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/my-board-of-directors"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="My Board of Directors"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/group-coworking"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Group Coworking"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/group-coaching"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Group Coaching"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/group-meditation"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Group Meditation"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/discussion-board"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Discussion Board"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/accountability-triads"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Accountability Triads"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/peer-coaching"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Peer Coaching"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/annual-goal-buddy"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Annual Goal Buddy"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/reading-buddy"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Reading Buddy"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/my-notebook"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="My Notebook"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/meditations"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Meditations"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/mindset-goals"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Mindset Goals"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/building-confidence"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Building Confidence"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/envisioning-yourself"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Envisioning Yourself"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/influence-zones"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Influence Zones"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/past-roles-reflection"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Past Roles Reflection"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/mindset/networking-preparation"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Networking Preparation"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/other-videos"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Other Videos"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/other-books"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Other Books"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/other-blogs"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Other Blogs"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/podcasts"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Podcasts"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/templates"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Templates"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/whiteboard"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Whiteboard"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/key-links"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Key Links"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/settings"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Settings"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/security"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Security"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/my-plan"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="My Plan"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/billing"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Billing"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/integrations"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Integrations"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/accountability/progress-tracker"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Progress Tracker"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/accountability/suggested-schedule"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Suggested Schedule"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/accountability/my-tasks"
                    exact
                    render={(props) => (
                      <>
                        <div style={{margin: "auto 20%"}} className="my-tasks-screen">
                          <Mytasks />
                        </div>
                      </>
                    )}
                  />
                  <Route
                    path="/accountability/group-coworking"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Group Coworking"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/compare-roles"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Compare Roles"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/pie-chart-exercise"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Pie Chart Exercise"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/resume-vision-exercise"
                    exact
                    render={(props) => (
                       <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Resume Vision Exercise"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/key-definitions"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Key Definitions"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/identify-gaps"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Identify Gaps"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/career-trajectory"
                    exact
                    render={(props) => (
                      <>
                        <div style={{margin: "auto 20%"}}>
                          <Timeline />
                        </div>
                      </>
                    )}
                  />
                  <Route
                    path="/upskilling/strengths-overview"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Strengths Overview"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/skill-gap-analysis"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Skill Gap Analysis"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/job-posting-exercise"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Job Posting Exercise"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/upskilling-tracker"
                    exact
                    render={(props) => (
                      <Learningbase
                        current_step={0}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/compare-options"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Compare Options"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/education-planning"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Education Planning"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/my-credentials"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="My Credentials"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/key-links"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Key Links"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/soft-skill-development"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Soft Skill Development"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/boundary-setting"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Boundary Setting"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/communication"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Communication"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/time-management"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Time Management"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/project-management"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Project Management"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/improving-focus"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Improving Focus"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/upskilling/influence-and-visibility"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Influence & Visibility"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/progress-tracker"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Progress Tracker"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/strategy-and-direction"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Strategy & Direction"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/my-schedule"
                    exact
                    render={(props) => (
                      <CalendarBase toggle={toggle} collapsed={collapsed} />
                    )}
                  />
                  <Route
                    path="/job-searching/suggested-schedule"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Suggested Schedule"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/target-job-postings"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Target Job Postings"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/target-companies"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Target Companies"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/staffing-agencies"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Staffing Agencies"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/visa-resources"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Visa Resources"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/set-priorities"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Set Priorities"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/job-search-tracker"
                    exact
                    render={(props) => (
                      <JobSearchBase
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/research-roles"
                    exact
                    render={(props) => (
                      <Researchroles
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/industry-research"
                    exact
                    render={(props) => (
                      <Researchindustries
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/research-industries"
                    exact
                    render={(props) => (
                      <Researchindustries
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/contacts-brainstorm"
                    exact
                    render={(props) => (
                      <Networkingbase
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/outreach-drafts"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={1}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/networking-tracker"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/contacts-brainstorm"
                    exact
                    render={(props) => (
                      <Networkingbase
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/outreach-drafts"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={1}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/networking-tracker"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/call-prep"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={3}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-path-exploration/reflections"
                    exact
                    render={(props) => (
                      <WeeklyReflections
                        current_step={0}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        type={WEEKLY_REFLECTION_TYPES.NETWORKING}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/contacts"
                    exact
                    render={(props) => (
                      <Networkingbase
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/email-drafts"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={1}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/tracker"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/call-prep"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={3}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/call-notes"
                    exact
                    render={(props) => (
                      <Networkingbase
                        current_step={4}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/reflections"
                    exact
                    render={(props) => (
                      <WeeklyReflections
                        current_step={0}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        type={WEEKLY_REFLECTION_TYPES.NETWORKING}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/learning-opportunities"
                    exact
                    render={(props) => (
                      <Learningbase
                        current_step={0}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/professional-summary"
                    exact
                    render={(props) => (
                      <Materialsbase
                        // current_step={4}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/materials/professional-summary"
                    exact
                    render={(props) => (
                      <Materialsbase
                        // current_step={4}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/resume"
                    exact
                    render={(props) => (
                      <Materialsbase
                        current_step={1}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/materials/resume"
                    exact
                    render={(props) => (
                      <Materialsbase
                        current_step={1}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/materials/cover-letter"
                    exact
                    render={(props) => (
                      <Materialsbase
                        current_step={3}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/cover-letter"
                    exact
                    render={(props) => (
                      <Materialsbase
                        current_step={3}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/video-pitch"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Video Pitch"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/portfolio-or-website"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Portfolio/Website"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/thought-leadership"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Thought Leadership"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/ats-keywords"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="ATS Keywords"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/mindset-preparation"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Mindset Preparation"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/networking/places-to-network"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Places to Network"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/events/past-events"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Past Events"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/events/upcoming-events"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Upcoming Events"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/events/find-events"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Find Events"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/onboarding-30-60-90"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Onboarding 30/60/90"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/onboarding-checklist"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Onboarding Checklist"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/promotions"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Promotions"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/internal-mobility"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Internal Mobility"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/performance-reviews"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Performance Review"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/job-expectations"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Job Expectations"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/annual-goals"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Annual Goals"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/stakeholder-updates"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Stakeholder Updates"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/career-advancement/track-achievements"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Track Achievements"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/roadmap"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Roadmap"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/customer-personas"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Customer Personas"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/market-research"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Market Research"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/define-offerings"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Define Offerings"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/financials"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Financials"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/marketing"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Marketing"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/sales"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Sales"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/product-development"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Product Development"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/team-management"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Team Management"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/legal"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Legal"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/entrepreneurship/operations"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Operations"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/questions-to-ask"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Questions to Ask"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/mock-interview"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Mock Interview"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/case-interview"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Case Interview"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/technical-interview"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Technical Interview"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/interview-follow-ups"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Interview Follow-Ups"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/standing-out"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Standing Out"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/offer-analysis"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Offer Analysis"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/salary-research"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Salary Research"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/reflections"
                    exact
                    render={(props) => (
                      // <div className="component-comingSoomComing Soon</div>
                      <WeeklyReflections
                        current_step={0}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        type={WEEKLY_REFLECTION_TYPES.JOB_SEARCH}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/key-links"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Key Links"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/helpful-tools"
                    exact
                    render={(props) => (
                      <ComingSoonScreenLayout
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        title="Helpful Tools"
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/materials/linkedin"
                    exact
                    render={(props) => (
                      <Materialsbase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/personal-branding/linkedin-profile"
                    exact
                    render={(props) => (
                      <Materialsbase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-search/application-tracker"
                    exact
                    render={(props) => (
                      <JobSearchBase
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/interview-research"
                    exact
                    render={(props) => (
                      <JobSearchBase
                        current_step={1}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-searching/interview-responses"
                    exact
                    render={(props) => (
                      <JobSearchBase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-search/interview-research"
                    exact
                    render={(props) => (
                      <JobSearchBase
                        current_step={1}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-search/interview-prep"
                    exact
                    render={(props) => (
                      <JobSearchBase
                        current_step={2}
                        toggle={toggle}
                        impersonated={!impersonated()}
                        collapsed={collapsed}
                        {...props}
                      />
                    )}
                  />
                  <Route
                    path="/job-search/reflections"
                    exact
                    render={(props) => (
                      <WeeklyReflections
                        current_step={0}
                        toggle={toggle}
                        collapsed={collapsed}
                        impersonated={!impersonated()}
                        type={WEEKLY_REFLECTION_TYPES.JOB_SEARCH}
                        {...props}
                      />
                    )}
                  />
                </div>
              </Content>
            </Layout>

            
            <Content 
              style={{
                backgroundColor: "#ffffff",
                overflowX: "visible",
                minHeight: "150vh",
                boxShadow: "-10px 0px 30px 0px #00000014"
              }}
              hidden
              className={[
                "source-element main-right-container",
              ].join(" ")} >

                <div style={{boxShadow: "0px 4px 20px 0px #0000000F"}}>
                  <Row style={{ minHeight: "72px", maxHeight:"72px", alignItems: "center", padding: "0 20px", }}>

                    {/* <Col span={9}> */}
                    <Col span={24}>
                      <div 
                        className="username-header-top"
                        style={{ 
                          textAlign: "left",
                          fontSize: "20px",
                          fontWeight: '800',
                          color: "#111111",
                          padding: "2% 1%",
                          fontFamily:'AvenirBook',
                          width: 'fit-content',
                          lineHeight: "27.32px",
                          display: "flex",
                          columnGap: "10px",
                          alignItems: "center",
                        }}>
                        <p>Customize Dashboard</p>
                        {/* <CustomizeDash setDraggedItem={setDraggedItem} /> */}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                        
                    </Col>
                  </Row>
                </div>

            </Content>


          </Layout>


          {!impersonated() &&
            typeof showNewStepModal === "object" &&
            Object.keys(showNewStepModal)
              .sort((a, b) => stepOrder(b) - stepOrder(a))
              .map((item, index) => (
                <NewStep
                  key={index}
                  // visible={showNewStepModal[item]}
                  visible={stepsAutoUnlockObj[item]?.auto_unlock ? !showNewStepModal[item] : showNewStepModal[item]}
                  stepKey={item}
                  onClose={() => notifiedNewStep(item)}
                  mask={index === 0}
                />
              ))}


          {console.log(
            "quickrefinfo",
            quickReflectionInfo,
            window.location.pathname
          )}
          <QuickReflection
            visible={quickReflectionInfo.show}
            stepId={quickReflectionInfo.stepId}
            path={window.location.pathname}
          />
          <FeedbackModal
              visible ={showFeedback}
          ></FeedbackModal>
          <ThankYou visible={showThankYou} onClose={props.closeThankYou} />

          {visibleProfileModal && (
            <Profile
              visible={visibleProfileModal}
              handleCancel={() => showProfileModal(false)}
            />
          )}
          {!isLocked("MI") && Object.keys(stepReflections).length > 0 && (
            <Midwaycall visible={true} obj={stepReflections["MI"]} />
          )}
          {!isLocked("NP") &&
            Object.keys(stepReflections).length > 0 &&
            Object.keys(stepReflections).includes("NP") && (
              <Skipstep visible={true} obj={stepReflections["NP"]} />
            )}
        </div>
      ) : (
        <LoadingOutlined
          style={{ fontSize: 50, color: "#7fced2", marginTop: "50px" }}
        />
      )}
    </>
  );
};

const BaselayoutContainer = ({ props }) => {
  const fetched = useSelector(selectFetched);
  const dispatch = useDispatch();


  useEffect(() => {
    // console.log('$$woken$$', 'dashboard current state', { tasks, fetched });
    if (!fetched) {
      // console.log('$$woken$$', 'Dispatching fetchDataAsync...');
      dispatch(fetchDataAsync());
      dispatch(fetchRolesAsync());
      dispatch(fetchIndustriesAsync());
      dispatch(fetchWorkEnvironmentsAsync());
      dispatch(fetchUpcomingMeetingsAsync(localStorage.getItem("user_id")));
      dispatch(fetchShortTermGoalsAsync(localStorage.getItem("user_id")));
      dispatch(fetchProfessionalSummaryAsync(localStorage.getItem("user_id")));
      dispatch(fetchCoachSummaryAsync(localStorage.getItem("user_id")));
      dispatch(fetchTimelineAsync(localStorage.getItem("user_id")));
      dispatch(fetchTimelineStepAsync(localStorage.getItem("user_id")));
      // window.setInterval(function(){
      //   message.success('Your work has been saved!')
      // }, 60000)
      // HELPERS.changesSaved(()=>message.success('Your work has been saved!'))
    }
  }, []);

  const closeThankYou = () => {
    dispatch(setShowThankYou(false));
  };

  return (
    <Baselayout fetched={fetched} closeThankYou={closeThankYou} {...props} />
  );
};

export default BaselayoutContainer;
